import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStorageService } from '@services';
import moment from 'moment-timezone';

@Pipe({
  name: 'userDateHtml',
})
export class UserDateFormatWithHTMLPipe implements PipeTransform {
  constructor(
    private locaStorageService: LocalStorageService,
    private sanitizer: DomSanitizer
  ) {}

  transform(date) {
    if (!date) return this.sanitizer.bypassSecurityTrustHtml(`<div>-</div>`);
    
    // Create moment object based on date format
    let momentDate;
    
    // Check if date has timezone info (ISO format with Z or timezone offset)
    if (this.hasTimezoneInfo(date)) {
      momentDate = moment(date);
    } else {
      // Assume it's UTC if no timezone info (backend format: "2024-11-27 03:22:34")
      momentDate = moment.utc(date);
    }
    
    if (!momentDate.isValid()) {
      return this.sanitizer.bypassSecurityTrustHtml(`<div>-</div>`);
    }
    
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const UserTimeZone = this.locaStorageService.userTimezone || localTimezone;
    const DateInTimezone = momentDate.tz(UserTimeZone);
    
    const DateTimeDynamicHTML = `
      <div>
        <div>${this.getTodayOrYesterday(momentDate, UserTimeZone)} at ${DateInTimezone.format('h:mm a')}
        </div>
      </div>
    `;
    
    return this.sanitizer.bypassSecurityTrustHtml(DateTimeDynamicHTML);
  }

  private hasTimezoneInfo(dateString: string): boolean {
    // Check for ISO format with Z or timezone offset
    return dateString.includes('T') && (dateString.includes('Z') || /[+-]\d{2}:\d{2}$/.test(dateString));
  }

  private getTodayOrYesterday(momentDate: moment.Moment, timezone: string): string {
    const DateInTimezone = momentDate.tz(timezone);
    const today = moment().tz(timezone);
    const yesterday = moment().tz(timezone).subtract(1, 'days');
    const currentYear = moment().year();

    if (DateInTimezone.isSame(today, 'day')) {
      return 'Today';
    } else if (DateInTimezone.isSame(yesterday, 'day')) {
      return 'Yesterday';
    } else {
      // Add year only if it's not the current year
      if (DateInTimezone.year() !== currentYear) {
        return DateInTimezone.format('MMM D, YYYY');
      } else {
        return DateInTimezone.format('MMM D');
      }
    }
  }
}